import * as React from 'react';
import PropTypes from 'prop-types';
import { styled, alpha } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import CachedIcon from '@mui/icons-material/Cached';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { IconButton } from '@mui/material';
import { useTheme } from 'next-themes';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function SettingsMenu({
  handleDropDownOption,
  memberId,
  userRole,
  userName,
  id,
  setModalType,
  handleModalOpen,
  selectedTeam,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { theme } = useTheme();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRoleAssign = (event, memId, memName, memRole) => {
    handleClose(event);
    setModalType('assignRole');
    handleModalOpen(memId, memName, memRole);
  };

  const disabledActions = () => {
    if (userRole === 'owner') {
      return true;
    }
    return false;
  };
  return (
    <div>
      <IconButton
        onClick={handleClick}
        sx={{
          '&.Mui-disabled > .MuiSvgIcon-root': {
            color: 'rgba(0, 0, 0, 0.25)',
          },
        }}
        disabled={disabledActions()}
      >
        <MoreVertIcon
          htmlColor={
            disabledActions() ? 'gray' : theme === 'dark' ? 'white' : 'black'
          }
        />
      </IconButton>
      <StyledMenu
        id='demo-customized-menu'
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {!['owner', 'invited']?.includes(userRole) ? (
          <MenuItem
            disableRipple
            disabled={['owner'].includes(userRole)}
            onClick={(e) => handleRoleAssign(e, id, userName, userRole)}
          >
            <SupervisorAccountIcon />
            Assign Role
          </MenuItem>
        ) : null}
        {!['member', 'administrator']?.includes(userRole) ? (
          <MenuItem
            disableRipple
            disabled={['owner'].includes(userRole)}
            onClick={(event) => {
              handleClose(event);
              handleDropDownOption('resend', memberId);
            }}
          >
            <CachedIcon />
            Resend Invite
          </MenuItem>
        ) : null}
        <MenuItem
          disableRipple
          disabled={['owner'].includes(userRole)}
          onClick={(event) => {
            handleClose(event);
            handleDropDownOption('delete', memberId, userRole);
          }}
        >
          <DeleteIcon />
          {userRole === 'invited' ? 'Cancel Invite' : 'Remove User'}
        </MenuItem>
      </StyledMenu>
    </div>
  );
}

SettingsMenu.propTypes = {
  handleDropDownOption: PropTypes.func,
  setModalType: PropTypes.func,
  handleModalOpen: PropTypes.func,
  memberId: PropTypes.string,
  userRole: PropTypes.string,
  userName: PropTypes.string,
  selectedTeam: PropTypes.object,
  id: PropTypes.string,
};
